import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/afterSale"),
    name: "afterSale",
    children: [
      {
        path: "o/c",
        component: () => import("@/views/afterSale/create"),
        name: "afterSaleCreate",
        meta: { version: "old" },
      },
      {
        path: "o/d",
        component: () => import("@/views/afterSale/details"),
        name: "afterSaleDetails",
        meta: { version: "old" },
      },
      {
        path: "a/c",
        component: () => import("@/views/afterSale/create"),
        name: "afterSaleCreate",
        meta: { version: "old" },
      },
      {
        path: "a/d",
        component: () => import("@/views/afterSale/details"),
        name: "afterSaleDetails",
        meta: { version: "old" },
      },
      {
        path: "a/repair",
        component: () => import("@/views/repair"),
        name: "repair",
        redirect: "a/repair/selfService",
        children: [
          {
            path: "selfService",
            component: () => import("@/views/repair/selfService"),
            name: "SelfService",
            meta: {
              key: "SelfService",
              version: "new",
            },
          },
          {
            path: "repairReq",
            component: () => import("@/views/repair/repairReq"),
            name: "RepairReq",
            meta: {
              key: "RepairReq",
              version: "new",
            },
          },
          {
            path: "repairReqMobile",
            component: () => import("@/views/repair/repairReqMobile"),
            name: "RepairReqMobile",
            meta: {
              key: "RepairReq",
              version: "new",
            },
          },
          {
            path: "repairSuccess",
            component: () => import("@/views/repair/repairSuccess"),
            name: "RepairSuccess",
            meta: {
              key: "RepairSuccess",
              version: "new",
            },
          },
          {
            path: "repairTrace",
            component: () => import("@/views/repair/repairTrace"),
            name: "RepairTrace",
            meta: {
              key: "RepairTrace",
              version: "new",
            },
          },
          {
            path: "invoice",
            component: () => import("@/views/repair/invoice"),
            name: "Invoice",
            meta: {
              key: "Invoice",
              version: "new",
            },
          },
          {
            path: "repairTraceDetails",
            component: () => import("@/views/repair/repairTrace/details"),
            name: "RepairTraceDetails",
            meta: {
              key: "RepairTrace",
              version: "new",
            },
          },
          {
            path: "repairUpdate",
            component: () => import("@/views/repair/repairUpdate"),
            name: "RepairUpdate",
            meta: {
              key: "RepairUpdate",
              version: "new",
            },
          },
          {
            path: "repairUpdateDetails",
            component: () => import("@/views/repair/repairUpdate/details"),
            name: "RepairUpdateDetails",
            meta: {
              key: "RepairUpdate",
              version: "new",
            },
          },
          {
            path: "partsPrice",
            component: () => import("@/views/repair/partsPrice"),
            name: "PartsPrice",
            meta: {
              key: "PartsPrice",
              version: "new",
            },
          },
        ],
      },
      {
        path: "a/repairPolicy",
        component: () => import("@/views/repair/repairPolicy"),
        name: "repairPolicy",
        meta: { version: "new" },
      },
      {
        path: "a/privacyPolicy",
        component: () => import("@/views/repair/privacyPolicy"),
        name: "privacyPolicy",
        meta: { version: "new" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
